import { useAtomValue } from "jotai";
import { colors } from "theme";

import Car from "components/Car";
import ClientTranslation from "components/ClientTranslation";
import Feedback from "components/Feedback";
import Flex from "components/Flex";
import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { estimateAtom } from "atoms/estimate";
import { useClientTranslation } from "hooks/useClientTranslation";
import { usePageTracking } from "hooks/usePageTracking";

import TractableLogo from "../../components/TractableLogo";

export const TotalLoss = () => {
  usePageTracking({ name: "Total loss - view" });

  const estimate = useAtomValue(estimateAtom);

  const { t } = useClientTranslation();

  return (
    <Feedback>
      <PageLayout title={t("total_loss.header")} dataTestId="totalLoss">
        <Flex flex={1} mx={24} mb={32} mt={8} gap={16}>
          <Flex gap={8}>
            <Text sizeVariant="md">
              <ClientTranslation i18nKey="total_loss.description">{t("total_loss.description")}</ClientTranslation>
            </Text>
          </Flex>

          {estimate && (
            <Flex mt={24} direction="row" justify="center">
              <Car scale={1.1} orientation="vertical" totalLoss damagedParts={estimate.damagedParts} />
            </Flex>
          )}

          <Flex flex={1} direction="row" justify="center" mt={24} align="flex-end" gap={8}>
            <TractableLogo />
            <Text sizeVariant="md" style={{ color: colors.grey[90] }}>
              {t("global.powered_by_tractable")}
            </Text>
          </Flex>
        </Flex>
      </PageLayout>
    </Feedback>
  );
};
